import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/kalindi.dcpltechnology.com/src/app/login/index.js");
